var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 105,
    viewBox: "0 0 119 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.66 36.42C71.29 36.42 62.77 36.08 54.8 33.86C46.98 31.69 39.8 27.48 33.4 22.61C29.21 19.44 25.4 16.92 19.96 17.3C14.6335 17.5916 9.5424 19.5902 5.44001 23C-1.47999 29 -0.439991 40.23 2.33001 48.12C6.49001 60 19.15 68.23 29.91 73.61C42.34 79.82 56 83.42 69.69 85.5C81.69 87.32 97.11 88.65 107.51 80.81C117.06 73.61 119.68 57.17 117.34 46.07C116.773 42.7879 115.027 39.8258 112.43 37.74C105.72 32.84 95.71 36.11 88.17 36.28C85.37 36.34 82.52 36.41 79.66 36.42Z",
    fill: "#E6F2CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.18 104.95C79.4544 104.95 95.89 103.925 95.89 102.66C95.89 101.395 79.4544 100.37 59.18 100.37C38.9056 100.37 22.47 101.395 22.47 102.66C22.47 103.925 38.9056 104.95 59.18 104.95Z",
    fill: "#E6F2CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54 72.43C7.08124 72.43 7.52 71.9912 7.52 71.45C7.52 70.9088 7.08124 70.47 6.54 70.47C5.99876 70.47 5.56 70.9088 5.56 71.45C5.56 71.9912 5.99876 72.43 6.54 72.43Z",
    fill: "#E6F2CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.78 84.86V89.17",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.63 87.02H50.93",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.41 17.08H17.94C15.8082 17.08 14.08 18.8082 14.08 20.94V77.51C14.08 79.6418 15.8082 81.37 17.94 81.37H100.41C102.542 81.37 104.27 79.6418 104.27 77.51V20.94C104.27 18.8082 102.542 17.08 100.41 17.08Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.64 28H25.76C24.2357 28 23 29.2357 23 30.76V66.71C23 68.2343 24.2357 69.47 25.76 69.47H91.64C93.1643 69.47 94.4 68.2343 94.4 66.71V30.76C94.4 29.2357 93.1643 28 91.64 28Z",
    fill: "white",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.55 11.42C91.0912 11.42 91.53 10.9812 91.53 10.44C91.53 9.89875 91.0912 9.45999 90.55 9.45999C90.0088 9.45999 89.57 9.89875 89.57 10.44C89.57 10.9812 90.0088 11.42 90.55 11.42Z",
    fill: "#E6F2CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.31 12.28C29.8513 12.28 30.29 11.8412 30.29 11.3C30.29 10.7588 29.8513 10.32 29.31 10.32C28.7688 10.32 28.33 10.7588 28.33 11.3C28.33 11.8412 28.7688 12.28 29.31 12.28Z",
    fill: "#E6F2CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.39 4.81V9.11",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.24 6.95999H56.54",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31 0.929993V5.22999",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16 3.08H11.47",
    stroke: "#E6F2CC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2 57.98C46.8364 55.1398 48.4212 52.6009 50.6933 50.7816C52.9654 48.9624 55.7893 47.9711 58.7 47.9711C61.6107 47.9711 64.4346 48.9624 66.7067 50.7816C68.9788 52.6009 70.5635 55.1398 71.2 57.98",
    stroke: "#80BC00",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8301 43.06C73.8131 43.06 74.6101 42.2631 74.6101 41.28C74.6101 40.2969 73.8131 39.5 72.8301 39.5C71.847 39.5 71.05 40.2969 71.05 41.28C71.05 42.2631 71.847 43.06 72.8301 43.06Z",
    fill: "#80BC00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.58 43.06C45.5631 43.06 46.36 42.2631 46.36 41.28C46.36 40.2969 45.5631 39.5 44.58 39.5C43.5969 39.5 42.8 40.2969 42.8 41.28C42.8 42.2631 43.5969 43.06 44.58 43.06Z",
    fill: "#80BC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.28f4cddcea492ed8fce20e250e225d73.svg";
export { ForwardRef as ReactComponent };